document.addEventListener('algolia.hooks.initialize', function() {  
    var myProducts = [];
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
        let product = myProducts[hit.id];
        search_page_total_records += 1;
        
        // Calculate ratio for aspect ratio (matching DAWN logic)
        let ratio = 1;
        if (hit.product_image && '' == 'portrait') {
            ratio = 0.8;
        } else if (hit.product_image && '' == 'adapt') {
            // You might need to pass aspect ratio data from your Algolia index
            ratio = hit.image_aspect_ratio || 1;
        }
        if (ratio == 0 || ratio == null) {
            ratio = 1;
        }
    
        return html`
            <div class="card-wrapper product-card-wrapper underline-links-hover">
                <div
                    class="
                        card card--card
                        ${hit.product_image ? 'card--media' : 'card--text'}
                         color-scheme-0996e2a3-9bbe-49c1-8f13-f09c49aaf970 gradient
                        
                        card--extend-height
                        ${!hit.product_image && 'card' == 'card' ? 'ratio' : ''}
                    "
                    style="--ratio-percent: ${100 / ratio}%;"
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    data-handle="${hit.handle}"
                    data-variant-id="${hit.objectID}"
                    data-distinct="${hit._distinct}"
                    data-product-id="${hit.id}"
                >
                    <div
                        class="card__inner ${hit.product_image || 'card' == 'standard' ? ' ratio' : ''}"
                        style="--ratio-percent: ${100 / ratio}%;"
                    >
                        ${hit.product_image ? html`
                            <div class="card__media">
                                <div class="media media--transparent media--hover-effect">
                                    <img
                                        src="${hit.product_image}"
                                        alt="${hit.title}"
                                        class="motion-reduce"
                                        loading="lazy"
                                        style="width:100%"
                                    />
                                    ${hit.product_image_alt ? html`
                                        <img
                                            src="${hit.product_image_alt}"
                                            alt="${hit.title}"
                                            class="motion-reduce"
                                            loading="lazy"
                                            style="width:100%"
                                        />
                                    ` : ''}
                                </div>
                            </div>
                        ` : ''}
                        
                        <div class="card__content">
                            <div class="card__information">
                                <h3
                                    class="card__heading"
                                    ${!hit.product_image && 'card' == 'standard' ? `id="title--${hit.id}"` : ''}
                                >
                                    <a
                                        href="/products/${hit.handle}"
                                        id="StandardCardNoMediaLink--${hit.id}"
                                        class="full-unstyled-link"
                                        aria-labelledby="StandardCardNoMediaLink--${hit.id} NoMediaStandardBadge--${hit.id}"
                                        onclick="void(0)"
                                        title="${hit.title}"
                                    >
                                        ${hit.title}
                                    </a>
                                </h3>
                            </div>
                            <div class="card__badge top left">
                                ${hit.tags && hit.tags.includes("Sale") ? html`
                                    <span
                                        id="NoMediaStandardBadge--${hit.id}"
                                        class="badge badge--bottom-left color-scheme-8e9407be-d0f3-4623-9f58-ba0c7f277178"
                                    >
                                        Sale
                                    </span>
                                ` : ''}
                            </div>
                        </div>
                        
                        <!-- Swym Wishlist Plus EPI Button -->
                        <button
                            aria-label="Add to Wishlist"
                            data-with-epi="true"
                            class="swym-button swym-add-to-wishlist-view-product product_${hit.id}"
                            data-swaction="addToWishlist"
                            data-product-id="${hit.id}"
                            data-variant-id="${hit.objectID}"
                            data-product-url="https://medicalrite.com/products/${hit.handle}"
                        ></button>
                        <div class="quick-add quick-view no-js-hidden custom-quick-add-modal">
                            <modal-opener data-modal="#QuickAdd-${hit.id}">
                                <button
                                    id="quick-add-${hit.id}-submit"
                                    type="submit"
                                    name="add"
                                    class="quick-add__submit button button--full-width button"
                                    aria-haspopup="dialog"
                                    aria-labelledby="quick-add-${hit.id}-submit title-${hit.id}"
                                    data-product-url="/products/${hit.handle}"
                                    data-product-id="${hit.id}"
                                >
                                    <svg class="plus_icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_198_2016)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.88281 1.52002C6.88281 0.967735 6.43509 0.52002 5.88281 0.52002C5.33053 0.52002 4.88281 0.967735 4.88281 1.52002V5H1.40234C0.850059 5 0.402344 5.44771 0.402344 6C0.402344 6.55228 0.850059 7 1.40234 7H4.88281V10.48C4.88281 11.0323 5.33053 11.48 5.88281 11.48C6.43509 11.48 6.88281 11.0323 6.88281 10.48V7H10.3623C10.9146 7 11.3623 6.55228 11.3623 6C11.3623 5.44771 10.9146 5 10.3623 5H6.88281V1.52002Z" fill="white"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_198_2016">
                                        <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <span>Quick View</span>
                                    <div class="loading__spinner hidden">
                                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </button>
                            </modal-opener>
                            <algolia-quick-add-modal id="QuickAdd-${hit.id}" class="quick-add-modal">
                                <div
                                    role="dialog"
                                    aria-label="Choose options for "
                                    aria-modal="true"
                                    class="quick-add-modal__content global-settings-popup"
                                    tabindex="-1"
                                >
                                    <button
                                        id="ModalClose-${hit.id}"
                                        type="button"
                                        class="quick-add-modal__toggle"
                                        aria-label="Close"
                                    >
                                        <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                            <path fill="currentColor" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>
                                        </svg>
                                    </button>
                                    <div id="QuickAddInfo-${hit.id}" class="quick-add-modal__content-info"></div>
                                </div>
                            </algolia-quick-add-modal>
                        </div>
                    </div>
                    
                    <div class="card__content">
                        <div class="card__information">
                            <div class="card-information">
                                <div class="vendor-rating-wrapper">
                                    <!-- Vendor Display -->
                                    ${hit.vendor == 'Dealmed' ? html`
                                        <div class="original_brand">
                                            <div class="original-img-wrap">
                                                <img src="//medicalrite.com/cdn/shop/files/dealmed_1467578e-105d-4b78-b98c-ab6d8d28949b.png?v=1716913682&width=16" 
                                                    loading="lazy" 
                                                    class="dealmed-vendor-logo" 
                                                    alt="Dealmed Logo" />
                                            </div>
                                            <div class="original_text">Original</div>
                                        </div>
                                    ` : html`
                                        <span class="productitem--vendor">
                                            <a>${hit.vendor}</a>
                                        </span>
                                    `}
                                    
                                    <div class="custom_separator">|</div>
                                    
                                    <!-- Okendo Rating -->
                                    ${hit.meta?.okendo?.StarRatingSnippet ? html`
                                        <div data-oke-star-rating 
                                            data-oke-reviews-product-id="shopify-${hit.id}"
                                            dangerouslySetInnerHTML=${createHTML(hit.meta.okendo.StarRatingSnippet)}></div>
                                    ` : ''}
                                </div>
                                
                                <h3
                                    class="card__heading${hit.product_image || 'card' == 'standard' ? ' h5' : ''}"
                                    ${hit.product_image || 'card' == 'card' ? `id="title--${hit.id}"` : ''}
                                >
                                    <a
                                        href="/products/${hit.handle}"
                                        id="CardLink--${hit.id}"
                                        class="full-unstyled-link"
                                        aria-labelledby="CardLink--${hit.id} Badge--${hit.id}"
                                        onclick="void(0)"
                                        title="${hit.title}"
                                    >
                                        ${hit.title}
                                        ${hit.options?.sold_by && hit.options.sold_by !== "Single Piece" && hit.options.sold_by !== "each" && hit.options.sold_by !== "ea" ? 
                                            html`, <span class="title-sub-variant">${hit.options.sold_by}</span>` : ''}
                                    </a>
                                </h3>
                                
                                <!-- Price Section -->
                                <div class="price ${hit.variants_compare_at_price_min > hit.variants_min_price ? html `price--on-sale ` : ''} price--show-badge">
                                    <div class="price__container">
                                        <div class="price__regular">
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            ${hit.variants_count !== 1 ? html`
                                                <div class="price-item">
                                                    <span class="price__from">From</span>
                                                    <span class="price-item price-item--regular">
                                                        <span class="money">${algoliaShopify.helpers.displayPrice({price: hit.variants_min_price}, hit._distinct)}</span>
                                                    </span>
                                                </div>
                                            ` : 
                                            html`
                                                <span class="price-item price-item--regular">
                                                        <span class="money">${algoliaShopify.helpers.displayPrice({price: hit.variants_min_price}, hit._distinct)}</span>
                                                </span>
                                            `}
                                        </div>
                                        ${hit.variants_compare_at_price_min && hit.variants_compare_at_price_min > hit.variants_min_price ? html`
                                            <div class="price__sale">
                                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                <span>
                                                    <s class="price-item price-item--regular">${algoliaShopify.helpers.displayStrikedPrice(hit.variants_min_price, hit.variants_compare_at_price_min)}</s>
                                                </span>
                                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                <span class="price-item price-item--sale price-item--last">
                                                    ${hit.variants_count !== 1 ? html`<span class="price__from">From</span>` : ''}
                                                    <span class="money">${algoliaShopify.helpers.displayPrice({price : (hit.variants_min_price)}, hit._distinct)}</span>
                                                </span>
                                            </div>
                                        ` : ''}
                                            
                                    </div>
                                        
                                    ${(() => {
                                        if (hit.variants_compare_at_price_min && hit.variants_min_price) {
                                            const minDiscount = Math.round((hit.variants_compare_at_price_min - hit.variants_min_price) / hit.variants_compare_at_price_min * 100);
                                            const maxDiscount = hit.variants_compare_at_price_max && hit.variants_max_price ? 
                                                Math.round((hit.variants_compare_at_price_max - hit.variants_max_price) / hit.variants_compare_at_price_max * 100) : 0;
                                            const highestDiscount = Math.max(minDiscount, maxDiscount);
                                            
                                            return highestDiscount > 0 ? html`
                                                <span class="badge price__badge-save color-scheme-57979acc-2cf0-4397-9127-0a007ae8bd0c">
                                                    Save ${highestDiscount}%
                                                </span>
                                            ` : '';
                                        }
                                        return '';
                                    })()}
                                </div>
                            </div>
                        </div>
                        

                        <div class="quick-add no-js-hidden">
                            ${hit.variants_count > 1 ? html`
                                <modal-opener data-modal="#QuickAdd-${hit.id}">
                                    <button
                                        id="quick-add-${hit.id}-submit"
                                        type="submit"
                                        name="add"
                                        class="quick-add__submit button button--full-width button"
                                        aria-haspopup="dialog"
                                        aria-labelledby="quick-add-${hit.id}-submit title-${hit.id}"
                                        data-product-url="/products/${hit.handle}"
                                        data-product-id="${hit.id}"
                                    >
                                        Add to cart
                                        <div class="loading__spinner hidden">
                                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                            </svg>
                                        </div>
                                    </button>
                                </modal-opener>
                                <algolia-quick-add-modal id="QuickAdd-${hit.id}" class="quick-add-modal">
                                    <div
                                        role="dialog"
                                        aria-label="Choose options for "
                                        aria-modal="true"
                                        class="quick-add-modal__content global-settings-popup"
                                        tabindex="-1"
                                    >
                                        <button
                                            id="ModalClose-${hit.id}"
                                            type="button"
                                            class="quick-add-modal__toggle"
                                            aria-label="Close"
                                        >
                                            <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                                <path fill="currentColor" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>
                                            </svg>
                                        </button>
                                        <div id="QuickAddInfo-${hit.id}" class="quick-add-modal__content-info"></div>
                                    </div>
                                </algolia-quick-add-modal>
                            ` : html`
                                <algolia-product-form data-section-id="algolia-${hit.id}">
                                    <form action="/cart/add" method="post" enctype="multipart/form-data" class="form" novalidate="novalidate" data-type="add-to-cart-form" id="product form-${hit.id}">
                                        <input type="hidden" name="id" value="${hit.objectID}" class="product-variant-id" />
                                        <button
                                            id="ProductSubmitButton-${hit.id}"
                                            type="submit"
                                            name="add"
                                            class="quick-add__submit button button--full-width button"
                                            aria-labelledby="ProductSubmitButton-${hit.id} title-${hit.id}"
                                            aria-live="polite"
                                            data-sold-out-message="true"
                                        >
                                            <span>Add to cart</span>
                                            <span class="sold-out-message hidden">Sold out</span>
                                            <div class="loading__spinner hidden">
                                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
                                                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                                </svg>
                                            </div>
                                        </button>
                                    </form>
                                </algolia-product-form>
                            `}
                        </div>

                        <div class="view-full-product-link-wrapper">
                            <a href="/products/${hit.handle}" class="link product__view-details animate-arrow large-hide">
                                View Full Product
                            </a>
                        </div>
                        
                        <div class="card__badge top left">
                            ${!hit.available ? html`
                                <span
                                    id="Badge--${hit.id}"
                                    class="badge badge--bottom-left color-scheme-3"
                                >
                                    Sold out
                                </span>
                            ` : (hit.variants_compare_at_price_min > hit.variants_min_price && hit.available) ? html`
                                <span
                                    id="Badge--${hit.id}"
                                    class="badge badge--bottom-left color-scheme-8e9407be-d0f3-4623-9f58-ba0c7f277178"
                                >
                                    Sale
                                </span>
                            ` : ''}
                        </div>
                    </div>
                </div>
            </div>
        `;
    });
    algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function (_defaultTemplate, item, html) {
        return html`
            <label class="${item.cssClasses.label}">    
            ${item.isRefined
            ? html`
                    <input
                        type="checkbox"
                        class="${item.cssClasses.checkbox}"
                        checked
                    />
                    <span class="check_box_content"></span>
                    `
            : html`
                    <input type="checkbox" class="${item.cssClasses.checkbox}" />
                    <span class="check_box_content"></span>
                    `}
            ${item.label}
            <span class="${item.cssClasses.count}">
                ${algoliaShopify.helpers.formatNumber(item.count)}
            </span>
            </label>
        `;
    });
    
    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
        return html`
            <div class="ais-pages">
            
                <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
                <div class="ais-sort-button">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.36108 7.83344L11.5833 7.83333M4.36108 12.1667H8.69442M4.36108 3.5H15.1944M13.0278 14.6944L14.8333 16.5L16.6389 14.6944M14.8333 8.19444V16.0603" stroke="#1B1B1B" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Sort</span>
                </div>
                <div class="ais-facets-button">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_53_35764)">
                        <path d="M13.4922 13.0075C13.9631 13.0075 14.415 13.1951 14.748 13.528C14.96 13.74 15.1121 14.0005 15.1953 14.2829H16.5195C16.7954 14.2831 17.0194 14.507 17.0195 14.7829C17.0195 15.0589 16.7955 15.2827 16.5195 15.2829H15.1953C15.1122 15.5658 14.9602 15.8266 14.748 16.0388C14.415 16.3717 13.9631 16.5583 13.4922 16.5583C13.0215 16.5582 12.5702 16.3715 12.2373 16.0388C12.0251 15.8266 11.8732 15.5658 11.79 15.2829H4.5625C4.28636 15.2829 4.0625 15.059 4.0625 14.7829C4.0627 14.5069 4.28648 14.2829 4.5625 14.2829H11.79C11.8733 14.0005 12.0253 13.74 12.2373 13.528C12.5702 13.1952 13.0214 13.0076 13.4922 13.0075ZM13.4922 14.0075C13.2866 14.0076 13.0897 14.0898 12.9443 14.235C12.799 14.3804 12.7169 14.5774 12.7168 14.7829C12.7168 14.9885 12.7989 15.1863 12.9443 15.3317C13.0897 15.4769 13.2867 15.5582 13.4922 15.5583C13.6979 15.5583 13.8956 15.4771 14.041 15.3317C14.1864 15.1863 14.2686 14.9885 14.2686 14.7829C14.2684 14.5775 14.1863 14.3804 14.041 14.235C13.8956 14.0897 13.6979 14.0075 13.4922 14.0075ZM8.22656 8.2243C8.69745 8.2243 9.14941 8.4119 9.48242 8.74481C9.69442 8.95684 9.84646 9.21721 9.92969 9.49969H16.5195L16.6211 9.50946C16.8487 9.55622 17.0195 9.75825 17.0195 9.99969C17.0195 10.2412 16.8487 10.4432 16.6211 10.4899L16.5195 10.4997H9.92969C9.84651 10.7826 9.69459 11.0434 9.48242 11.2556C9.14942 11.5884 8.69739 11.7751 8.22656 11.7751C7.75595 11.7749 7.30455 11.5882 6.97168 11.2556C6.75953 11.0434 6.60757 10.7826 6.52441 10.4997H4.5625C4.28636 10.4997 4.0625 10.2758 4.0625 9.99969C4.06256 9.7236 4.28639 9.49969 4.5625 9.49969H6.52441C6.6076 9.21721 6.75965 8.95687 6.97168 8.74481C7.30457 8.41196 7.75582 8.22444 8.22656 8.2243ZM8.22656 9.2243C8.021 9.22444 7.82406 9.30652 7.67871 9.45184C7.53818 9.5924 7.45745 9.78109 7.45215 9.97919C7.45243 9.98601 7.4541 9.9928 7.4541 9.99969C7.4541 10.0062 7.4524 10.0128 7.45215 10.0192C7.45717 10.2178 7.53791 10.4077 7.67871 10.5485C7.82403 10.6936 8.02115 10.7749 8.22656 10.7751C8.43219 10.7751 8.62994 10.6938 8.77539 10.5485C8.92086 10.4031 9.00293 10.2054 9.00293 9.99969C9.00289 9.79416 8.92073 9.59724 8.77539 9.45184C8.62993 9.30645 8.43228 9.2243 8.22656 9.2243ZM11.5762 3.4411C12.0471 3.4411 12.499 3.62864 12.832 3.96161C13.044 4.17365 13.1961 4.43399 13.2793 4.71649H16.5225L16.623 4.72626C16.8511 4.77272 17.0225 4.97472 17.0225 5.21649C17.0225 5.45826 16.8511 5.66026 16.623 5.70673L16.5225 5.71649H13.2793C13.1961 5.99938 13.0442 6.26019 12.832 6.47235C12.499 6.80525 12.047 6.99188 11.5762 6.99188C11.1055 6.99179 10.6542 6.80507 10.3213 6.47235C10.1091 6.26019 9.95719 5.99938 9.87402 5.71649H4.5625C4.28636 5.71649 4.0625 5.49263 4.0625 5.21649C4.06256 4.9404 4.28639 4.71649 4.5625 4.71649H9.87402C9.95723 4.43398 10.1092 4.17367 10.3213 3.96161C10.6542 3.62872 11.1054 3.44119 11.5762 3.4411ZM11.5762 4.4411C11.3705 4.44119 11.1737 4.52327 11.0283 4.66864C10.8877 4.80921 10.8071 4.99784 10.8018 5.19598C10.802 5.20281 10.8037 5.2096 10.8037 5.21649C10.8037 5.22302 10.802 5.22956 10.8018 5.23602C10.8068 5.43463 10.8875 5.62448 11.0283 5.76532C11.1737 5.91049 11.3707 5.99179 11.5762 5.99188C11.7818 5.99188 11.9795 5.91066 12.125 5.76532C12.2705 5.61987 12.3525 5.42216 12.3525 5.21649C12.3525 5.01095 12.2703 4.81404 12.125 4.66864C11.9795 4.52319 11.7819 4.4411 11.5762 4.4411Z" fill="#1B1B1B"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_53_35764">
                        <rect width="20" height="20" fill="white" transform="translate(0.5)"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <span>Filter</span>
                </div>
                <div class="ais-facets">
                <div class="ais-clear-refinements-container"></div>
                <div class="ais-current-refined-values-container"></div>
                ${data.facets.map(
                    (facet) => {
            
                    return html`
                        <div
                        class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                        >
                        
                        <label
                            for="${facet.escapedName}"
                            class="ais-range-slider--header ais-facet--header ais-header"
                            >${facet.title == "Vendor" ? "Manufacturer" : facet.title == "Price Range" ? "Price" : facet.title}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_53_35142)">
                                <path d="M4 6L8 10L12 6" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_53_35142">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                            </svg>
                        </label>
                        <input
                            class="ais-dropdown-checkbox"
                            type="checkbox"
                            id="${facet.escapedName}"
                            name="dropdown"
                        />
                        <div class="custom-ais-facet-dropdown-container">
                            <div
                            class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                            ></div>
                            <div class="close_btn_container">
                                <button class="ais-facet-dropdown-close-btn">Close</button>
                            </div>
                        </div>
            
                        </div>
                    `
                    })
                    }
                <div class="results-facet-overlay">
                    <div class="ais-stats-container"></div>
                </div>
                </div>
                <div class="ais-input">
                <div class="ais-search-box-container"></div>
                <div class="ais-input-button">
                    <div class="ais-clear-input-icon"></div>
                </div>
                </div>
                <div class="ais-block">
                <div class="ais-search-header">
                    <div class="ais-stats-container"></div>
                    <div class="ais-change-display">
                    <span class="ais-change-display-block ais-change-display-selected"
                        ><i class="fa fa-th-large"></i
                    ></span>
                    <span class="ais-change-display-list"
                        ><i class="fa fa-th-list"></i
                    ></span>
                    </div>
                    <div class="ais-sort">
                    ${data.multipleSortOrders
                    ? html`
                            <span class="ais-sort-orders-container"></span>
                        `
                    : html`
                            ${algoliaShopify.translations.relevance}
                        `}
                    </div> 
                    
                </div>
                <div class="collection-count"></div>
                <div class="ais-hits-container ais-results-as-block ais-hits-container-main">
                    
                </div>
                </div>
                <div class="ais-pagination-container"></div>
            </div>
        `;
    });
    // Event listener for Algolia render
    document.addEventListener('algolia.instantSearch.onRender', async function () {
        await waitForElm('.ais-Pagination-item');
        paginationInit();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        if (collection == "all") {
            if (vendor_param) {
                // Replace jQuery selectors with querySelector/querySelectorAll
                const richTextHeading = document.querySelector('.collection-hero__title');
                const breadcrumbItem = document.querySelector('#uncomplicated-category-breadcrumb-final-item');
            
                if (richTextHeading) {
                    richTextHeading.textContent = vendor_param;
                }
                
                if (breadcrumbItem) {
                    breadcrumbItem.textContent = vendor_param;
                }
                
                
                setTimeout(() => {
                const url = new URL(window.location.href);
                // Set or update a query parameter
                url.searchParams.set('vendor', vendor_param);
                // Update the URL without reloading the page
                window.history.pushState({}, '', url);
                }, 1000);

                document.querySelector('.sub-collections-scroll-container').closest('.shopify-section').style.display = 'none';
                document.querySelector('.featured-products-collection').style.display = 'none';
            }
        }

    });
    
    algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {
      if(defaultFilter) {
        if(collection == "all"){
          if(vendor_param){
              return defaultFilter + ' AND vendor:"'+vendor_param+'"'
          }
          return defaultFilter;
        }
        return defaultFilter;
        
      }
      else {
        return defaultFilter
      }
    });

    algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function(limit) {
        return 100;
    });
});
// function handleItemClick(event, hit) {
//     const isQuickViewClick = event.target.closest('.quick-shop-feat-collection-btn');
//     const isWishlistClick = event.target.closest('.swym-button');

//     if (isWishlistClick) {
//         return;
//     }

//     // Prevent default behavior
//     event.preventDefault();

//     // Store click data in sessionStorage (since localStorage isn't supported in this environment)
//     const clickData = {
//         eventName: "Product Clicked",
//         index: hit.index,
//         queryID: hit.queryID,
//         objectIDs: [hit.objectID]
//     };

//     const storageKey = "algolia_analytics_clicked_objects";
//     let storedData = JSON.parse(sessionStorage.getItem(storageKey) || "[]");
//     storedData.push(clickData);
//     sessionStorage.setItem(storageKey, JSON.stringify(storedData));

//     // If the click was on these elements, don't redirect
//     if (isQuickViewClick) {
//         return;
//     }

//     // Navigate to product page with or without variant parameter
//     const isClickedOnCustomButton = event.target.closest('.multiple-variant-atc') || 
//                                    event.target.closest('.single-variant-atc');
    
//     if (!isClickedOnCustomButton) {
//         let redirectUrl = algoliaShopify.helpers.instantsearchLink(hit);
//         if (hit.variants_count !== 1) {
//             // Add variant parameter if URL already has parameters
//             if (redirectUrl.includes('?')) {
//                 redirectUrl += `&variant=${hit.objectID}`;
//             } else {
//                 redirectUrl += `?variant=${hit.objectID}`;
//             }
//         }
//         window.location.href = redirectUrl;
//     }
// }

// Simple integration with DAWN's existing quick-add system
// Minimal script to make DAWN recognize Algolia elements
// document.addEventListener('DOMContentLoaded', function() {
//     function initAlgoliaElements() {
//         // Initialize any new modal-opener elements
//         document.querySelectorAll('.ais-hits-container modal-opener:not([data-dawn-ready])').forEach(opener => {
//             opener.setAttribute('data-dawn-ready', 'true');
//             // DAWN's ModalOpener class will handle this automatically
//             if (!customElements.get('modal-opener')) {
//                 // Modal opener functionality is already loaded by DAWN
//             }
//         });

//         // Initialize any new product-form elements  
//         document.querySelectorAll('.ais-hits-container product-form:not([data-dawn-ready])').forEach(form => {
//             form.setAttribute('data-dawn-ready', 'true');
//             // DAWN's ProductForm class will handle this automatically
//         });

//         // Initialize any new quick-add-modal elements
//         document.querySelectorAll('.ais-hits-container quick-add-modal:not([data-dawn-ready])').forEach(modal => {
//             modal.setAttribute('data-dawn-ready', 'true');
//             // DAWN's QuickAddModal class will handle this automatically
//         });
//     }

//     // Watch for Algolia updates and initialize new elements
//     const observer = new MutationObserver(function(mutations) {
//         let hasNewElements = false;
//         mutations.forEach(mutation => {
//             mutation.addedNodes.forEach(node => {
//                 if (node.nodeType === 1 && (
//                     node.querySelector('modal-opener') || 
//                     node.querySelector('product-form') || 
//                     node.querySelector('quick-add-modal')
//                 )) {
//                     hasNewElements = true;
//                 }
//             });
//         });
        
//         if (hasNewElements) {
//             setTimeout(initAlgoliaElements, 100);
//         }
//     });

//     const algoliaContainer = document.querySelector('.ais-hits-container');
//     if (algoliaContainer) {
//         observer.observe(algoliaContainer, { childList: true, subtree: true });
//     }

//     // Initial scan
//     setTimeout(initAlgoliaElements, 1000);
// });

document.addEventListener('DOMContentLoaded', function() {
    
    // Custom ProductForm class for Algolia elements
    class AlgoliaProductForm extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            this.form = this.querySelector('form');
            if (!this.form) return;
            
            this.variantIdInput = this.form.querySelector('[name=id]');
            if (this.variantIdInput) {
                this.variantIdInput.disabled = false;
            }
            
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');
            this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        }
    
        onSubmitHandler(evt) {
            evt.preventDefault();
            if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
            if (this.submitButton) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
            }
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.remove('hidden');
        
            // Use the same config as DAWN's product-form.js
            let config;
            if (typeof fetchConfig === 'function') {
                config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type']; // Let browser set it for FormData
            } else {
                // Fallback if fetchConfig not available
                config = {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                };
            }
        
            const formData = new FormData(this.form);
        
            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }
        
            config.body = formData;
        
            // Use routes global if available
            const cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        
            fetch(cartUrl, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
        
                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButtonText.classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = (window.routes && window.routes.cart_url) || '/cart';
                        return;
                    }
        
                    this.error = false;
                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                        document.body.addEventListener(
                            'modalClosed',
                            () => {
                                setTimeout(() => {
                                    this.cart.renderContents(response);
                                });
                            },
                            { once: true }
                        );
                        quickAddModal.hide(true);
                    } else {
                        this.cart.renderContents(response);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.handleErrorMessage('Unable to add to cart');
                })
                .finally(() => {
                    this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    if (spinner) spinner.classList.add('hidden');
                });
        }
    
        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    }

    // Custom QuickAddModal class for Algolia elements  
    class AlgoliaQuickAddModal extends HTMLElement {
        constructor() {
            super();
            
            // Add event listeners like DAWN's ModalDialog
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
            
            this.addEventListener('keyup', (event) => {
                if (event.code.toUpperCase() === 'ESCAPE') this.hide();
            });
        }

        connectedCallback() {
            // Auto-move to body like DAWN's ModalDialog
            if (this.moved) return;
            this.moved = true;
            
            // Find the closest section for dataset (similar to DAWN)
            const section = this.closest('.shopify-section');
            if (section) {
                this.dataset.section = section.id.replace('shopify-section-', '');
            }
            
            document.body.appendChild(this);
            
            // Initialize modal content area
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            
            // Add close button listener
            const closeBtn = this.querySelector('[id^="ModalClose-"]');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => this.hide());
            }
        }

        show(opener) {
            if (!opener) return;
            
            this.openedBy = opener;
            
            opener.setAttribute('aria-disabled', true);
            opener.classList.add('loading');
            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.remove('hidden');
        
            fetch(opener.getAttribute('data-product-url'))
                .then((response) => response.text())
                .then((responseText) => {
                    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                    const productElement = responseHTML.querySelector('product-info');
                    
                    if (productElement && this.modalContent) {
                        this.preprocessHTML(productElement);
                        
                        // Use DAWN's HTMLUpdateUtility instead of innerHTML
                        if (window.HTMLUpdateUtility) {
                            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
                        } else {
                            this.modalContent.innerHTML = productElement.outerHTML;
                        }
                        
                        // CRITICAL: Call initialization after content is set
                        setTimeout(() => {
                            this.initializeModalElements();
                        }, 50);
                    }
                    
                    document.body.classList.add('overflow-hidden');
                    this.setAttribute('open', '');
                    
                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    if (window.ProductModel) window.ProductModel.loadShopifyXR();
                    
                    if (window.trapFocus) {
                        window.trapFocus(this, this.querySelector('[role="dialog"]'));
                    }
                })
                .finally(() => {
                    opener.removeAttribute('aria-disabled');
                    opener.classList.remove('loading');
                    if (spinner) spinner.classList.add('hidden');
                });
        }
        
        // Add the preprocessing method from DAWN's QuickAddModal
        preprocessHTML(productElement) {
            productElement.classList.forEach((classApplied) => {
                if (classApplied.startsWith('color-') || classApplied === 'gradient')
                    this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs(productElement);
            this.removeDOMElements(productElement);
            this.updateImageSizes(productElement);
            this.preventVariantURLSwitching(productElement);
        }
        
        preventVariantURLSwitching(productElement) {
            productElement.setAttribute('data-update-url', 'false');
        }
        
        preventDuplicatedIDs(productElement) {
            const sectionId = productElement.dataset.section;
            const oldId = sectionId;
            const newId = `quickadd-${sectionId}`;
            productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
            Array.from(productElement.attributes).forEach((attribute) => {
                if (attribute.value.includes(oldId)) {
                    productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
                }
            });
            productElement.dataset.originalSection = sectionId;
        }
        
        removeDOMElements(productElement) {
            const pickupAvailability = productElement.querySelector('pickup-availability');
            if (pickupAvailability) pickupAvailability.remove();
        
            const productModal = productElement.querySelector('product-modal');
            if (productModal) productModal.remove();
        
            const modalDialog = productElement.querySelectorAll('modal-dialog');
            if (modalDialog) modalDialog.forEach((modal) => modal.remove());
        }
        
        updateImageSizes(productElement) {
            const product = productElement.querySelector('.product');
            const desktopColumns = product?.classList.contains('product--columns');
            if (!desktopColumns) return;
        
            const mediaImages = product.querySelectorAll('.product__media img');
            if (!mediaImages.length) return;
        
            let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        
            if (product.classList.contains('product--medium')) {
                mediaImageSizes = mediaImageSizes.replace('715px', '605px');
            } else if (product.classList.contains('product--small')) {
                mediaImageSizes = mediaImageSizes.replace('715px', '495px');
            }
        
            mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
        }
        
        initializeModalElements() {
            // Initialize all DAWN components first
            const productInfo = this.modalContent.querySelector('product-info');
            if (productInfo && customElements.get('product-info')) {
                customElements.upgrade(productInfo);
            }
        
            const variantSelects = this.modalContent.querySelector('variant-selects');
            if (variantSelects && customElements.get('variant-selects')) {
                customElements.upgrade(variantSelects);
            }
        
            const productForms = this.modalContent.querySelectorAll('product-form');
            productForms.forEach(form => {
                if (customElements.get('product-form')) {
                    customElements.upgrade(form);
                }
            });
        
            // CRITICAL: Execute inline scripts like the working version did
            const scripts = this.modalContent.querySelectorAll('script');
            scripts.forEach(script => {
                if (script.src) {
                    // External script - create new script element
                    const newScript = document.createElement('script');
                    newScript.src = script.src;
                    newScript.defer = script.defer;
                    document.head.appendChild(newScript);
                } else if (script.textContent) {
                    // Inline script - execute the code
                    try {
                        eval(script.textContent);
                    } catch (e) {
                        console.warn('Error executing inline script:', e);
                    }
                }
            });
        }

        hide(preventFocus = false) {
            document.body.classList.remove('overflow-hidden');
            document.body.dispatchEvent(new CustomEvent('modalClosed'));
            this.removeAttribute('open');
            
            if (this.modalContent) {
                this.modalContent.innerHTML = '';
            }
            
            // Remove focus trap like DAWN
            if (window.removeTrapFocus && this.openedBy && !preventFocus) {
                window.removeTrapFocus(this.openedBy);
            }
            
            if (window.pauseAllMedia) {
                window.pauseAllMedia();
            }
        }
    }

    // Define custom elements only once
    if (!customElements.get('algolia-product-form')) {
        customElements.define('algolia-product-form', AlgoliaProductForm);
    }
    if (!customElements.get('algolia-quick-add-modal')) {
        customElements.define('algolia-quick-add-modal', AlgoliaQuickAddModal);
    }

    // Function to initialize event listeners
    function initializeAlgoliaElements() {
        console.log('Initializing Algolia elements...');
    
        // Handle modal openers (modals auto-move to body via connectedCallback)
        document.querySelectorAll('.ais-hits-container modal-opener:not([data-algolia-ready])').forEach(opener => {
            opener.setAttribute('data-algolia-ready', 'true');
            
            const button = opener.querySelector('button');
            if (button) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    const modalId = opener.getAttribute('data-modal');
                    const modal = document.querySelector(modalId);
                    if (modal && modal.show) {
                        modal.show(button);
                    }
                });
            }
        });
    }

    // Event listeners
    document.addEventListener('algolia.instantSearch.onRender', function() {
        setTimeout(initializeAlgoliaElements, 100);
    });
    
    setTimeout(initializeAlgoliaElements, 1500);
});


// Helper function to wait for element
function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
  
      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
}
  
  // Main initialization
(async function initSearchInterface() {
// Prevent multiple executions
if (window.searchInterfaceInitialized) return;
window.searchInterfaceInitialized = true;

console.log('Initializing search interface...');

try {
    // Wait for the main element
    await waitForElm('.ais-Hits-item');
    console.log('Found ais-Hits-item');

    // Helper functions
    function isMobile() {
        return window.innerWidth <= 749;
    }

    // Mobile setup
    if (isMobile()) {
        // Basic layout setup
        const sort = document.querySelector('.ais-pages .ais-sort');
        const facets = document.querySelector('.ais-pages .ais-facets');
        
        if (sort && facets) {
            facets.appendChild(sort);
            console.log('Moved sort to facets');
        }

        const clearRefinements = document.querySelector('.ais-clear-refinements-container');
        const sortElement = document.querySelector('.ais-sort');
        
        if (clearRefinements && sortElement) {
            sortElement.parentNode.insertBefore(clearRefinements, sortElement);
            clearRefinements.style.position = 'relative';
            clearRefinements.style.marginTop = '5px';
            console.log('Positioned clear refinements');
        }

        const currentRefinedValues = document.querySelector('.ais-pages .ais-facets .ais-current-refined-values-container');
        if (currentRefinedValues && facets) {
            facets.appendChild(currentRefinedValues);
            console.log('Moved current refined values');
        }

        console.log('Setting up mobile interface...');
        
        const facetsButton = document.querySelector('.ais-facets-button');
        if (facetsButton) {
            facetsButton.innerHTML = '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_35764)"><path d="M13.4922 13.0075C13.9631 13.0075 14.415 13.1951 14.748 13.528C14.96 13.74 15.1121 14.0005 15.1953 14.2829H16.5195C16.7954 14.2831 17.0194 14.507 17.0195 14.7829C17.0195 15.0589 16.7955 15.2827 16.5195 15.2829H15.1953C15.1122 15.5658 14.9602 15.8266 14.748 16.0388C14.415 16.3717 13.9631 16.5583 13.4922 16.5583C13.0215 16.5582 12.5702 16.3715 12.2373 16.0388C12.0251 15.8266 11.8732 15.5658 11.79 15.2829H4.5625C4.28636 15.2829 4.0625 15.059 4.0625 14.7829C4.0627 14.5069 4.28648 14.2829 4.5625 14.2829H11.79C11.8733 14.0005 12.0253 13.74 12.2373 13.528C12.5702 13.1952 13.0214 13.0076 13.4922 13.0075ZM13.4922 14.0075C13.2866 14.0076 13.0897 14.0898 12.9443 14.235C12.799 14.3804 12.7169 14.5774 12.7168 14.7829C12.7168 14.9885 12.7989 15.1863 12.9443 15.3317C13.0897 15.4769 13.2867 15.5582 13.4922 15.5583C13.6979 15.5583 13.8956 15.4771 14.041 15.3317C14.1864 15.1863 14.2686 14.9885 14.2686 14.7829C14.2684 14.5775 14.1863 14.3804 14.041 14.235C13.8956 14.0897 13.6979 14.0075 13.4922 14.0075ZM8.22656 8.2243C8.69745 8.2243 9.14941 8.4119 9.48242 8.74481C9.69442 8.95684 9.84646 9.21721 9.92969 9.49969H16.5195L16.6211 9.50946C16.8487 9.55622 17.0195 9.75825 17.0195 9.99969C17.0195 10.2412 16.8487 10.4432 16.6211 10.4899L16.5195 10.4997H9.92969C9.84651 10.7826 9.69459 11.0434 9.48242 11.2556C9.14942 11.5884 8.69739 11.7751 8.22656 11.7751C7.75595 11.7749 7.30455 11.5882 6.97168 11.2556C6.75953 11.0434 6.60757 10.7826 6.52441 10.4997H4.5625C4.28636 10.4997 4.0625 10.2758 4.0625 9.99969C4.06256 9.7236 4.28639 9.49969 4.5625 9.49969H6.52441C6.6076 9.21721 6.75965 8.95687 6.97168 8.74481C7.30457 8.41196 7.75582 8.22444 8.22656 8.2243ZM8.22656 9.2243C8.021 9.22444 7.82406 9.30652 7.67871 9.45184C7.53818 9.5924 7.45745 9.78109 7.45215 9.97919C7.45243 9.98601 7.4541 9.9928 7.4541 9.99969C7.4541 10.0062 7.4524 10.0128 7.45215 10.0192C7.45717 10.2178 7.53791 10.4077 7.67871 10.5485C7.82403 10.6936 8.02115 10.7749 8.22656 10.7751C8.43219 10.7751 8.62994 10.6938 8.77539 10.5485C8.92086 10.4031 9.00293 10.2054 9.00293 9.99969C9.00289 9.79416 8.92073 9.59724 8.77539 9.45184C8.62993 9.30645 8.43228 9.2243 8.22656 9.2243ZM11.5762 3.4411C12.0471 3.4411 12.499 3.62864 12.832 3.96161C13.044 4.17365 13.1961 4.43399 13.2793 4.71649H16.5225L16.623 4.72626C16.8511 4.77272 17.0225 4.97472 17.0225 5.21649C17.0225 5.45826 16.8511 5.66026 16.623 5.70673L16.5225 5.71649H13.2793C13.1961 5.99938 13.0442 6.26019 12.832 6.47235C12.499 6.80525 12.047 6.99188 11.5762 6.99188C11.1055 6.99179 10.6542 6.80507 10.3213 6.47235C10.1091 6.26019 9.95719 5.99938 9.87402 5.71649H4.5625C4.28636 5.71649 4.0625 5.49263 4.0625 5.21649C4.06256 4.9404 4.28639 4.71649 4.5625 4.71649H9.87402C9.95723 4.43398 10.1092 4.17367 10.3213 3.96161C10.6542 3.62872 11.1054 3.44119 11.5762 3.4411ZM11.5762 4.4411C11.3705 4.44119 11.1737 4.52327 11.0283 4.66864C10.8877 4.80921 10.8071 4.99784 10.8018 5.19598C10.802 5.20281 10.8037 5.2096 10.8037 5.21649C10.8037 5.22302 10.802 5.22956 10.8018 5.23602C10.8068 5.43463 10.8875 5.62448 11.0283 5.76532C11.1737 5.91049 11.3707 5.99179 11.5762 5.99188C11.7818 5.99188 11.9795 5.91066 12.125 5.76532C12.2705 5.61987 12.3525 5.42216 12.3525 5.21649C12.3525 5.01095 12.2703 4.81404 12.125 4.66864C11.9795 4.52319 11.7819 4.4411 11.5762 4.4411Z" fill="#1B1B1B"/></g><defs><clipPath id="clip0_53_35764"><rect width="20" height="20" fill="white" transform="translate(0.5)"/></clipPath></defs></svg><span>Filter</span>';
            console.log('Updated facets button text');
        }

        if (facets && !facets.querySelector('.facets_scroll_container')) {
            console.log('Creating mobile structure...');
            
            // Create scroll container
            const scrollContainer = document.createElement('div');
            scrollContainer.className = 'facets_scroll_container';
            
            // Create overlay
            const overlay = document.createElement('div');
            overlay.className = 'facets_overlay';
            
            // Move existing children to scroll container (except what we're about to add)
            const existingChildren = Array.from(facets.children);
            existingChildren.forEach(child => {
            scrollContainer.appendChild(child);
            });
            
            // Add scroll container to facets
            facets.appendChild(scrollContainer);
            
            // Add overlay after facets button
            let facetsEle = document.querySelector('.ais-facets');
            if (facetsEle) {
                facetsEle.insertAdjacentElement('afterend', overlay);
            }

            // Add custom header
            const header = document.createElement('div');
            header.className = 'facet_custom_header';
            header.innerHTML = '<h4 class="filter_heading">Filters</h4><h4 class="sort_heading">Sort By</h4><span class="close_btn_for_filter hide_on_desktop"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 1L9 9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
            facets.insertBefore(header, facets.firstChild);
            
            console.log('Created mobile containers and header');

            // Reorganize elements within scroll container
            setTimeout(() => {
            const scrollSort = scrollContainer.querySelector('.ais-sort');
            const facetPrice = scrollContainer.querySelector('.ais-facet-price');
            
            if (scrollSort && facetPrice) {
                facetPrice.parentNode.insertBefore(scrollSort, facetPrice);
            }

            const scrollRefinedValues = scrollContainer.querySelector('.ais-current-refined-values-container');
            if (scrollRefinedValues) {
                scrollContainer.insertBefore(scrollRefinedValues, scrollContainer.firstChild);
            }

            const scrollClearRefinements = scrollContainer.querySelector('.ais-clear-refinements-container');
            if (scrollClearRefinements && scrollRefinedValues) {
                scrollRefinedValues.appendChild(scrollClearRefinements);
            }
            
            console.log('Reorganized mobile elements');
            }, 100);

            // Convert select to radio
            try {
                await waitForElm('.ais-SortBy-select');
                const selects = document.querySelectorAll('.ais-SortBy-select');
                
                selects.forEach(select => {
                // Check if already converted
                if (select.parentNode.querySelector('input[name="custom_sort_radio"]')) {
                    console.log('Select already converted to radio');
                    return;
                }
                
                const options = select.querySelectorAll('option');
                console.log('Converting', options.length, 'options to radio buttons');
                
                options.forEach(option => {
                    const wrapper = document.createElement('div');
                    wrapper.className = 'radio-option';
                    
                    const radio = document.createElement('input');
                    radio.type = 'radio';
                    radio.name = 'custom_sort_radio';
                    radio.value = option.value;
                    radio.id = `radio_${option.value}`;
                    
                    if (option.hasAttribute('selected') || option.selected) {
                    radio.checked = true;
                    }
    
                    const label = document.createElement('label');
                    label.setAttribute('for', radio.id);
                    label.textContent = option.textContent;
    
                    wrapper.appendChild(radio);
                    wrapper.appendChild(label);
                    select.parentNode.insertBefore(wrapper, select);
                });
                
                console.log('Converted select to radio for:', select);
                });
            } catch (error) {
            console.error('Error converting select to radio:', error);
            }
        }
    }

    // Event listeners (only add once)
    if (!window.searchEventListenersAdded) {
    window.searchEventListenersAdded = true;
    
    document.addEventListener('click', function(e) {
        // Close filter button
        if (e.target.matches('.close_btn_for_filter') || e.target.closest('.close_btn_for_filter') || e.target.closest('.results-facet-overlay .ais-stats-container .ais-Stats')) {
            console.log('Close button clicked');
            const facetsEl = document.querySelector('.ais-facets');
            const facetsBtn = document.querySelector('.ais-facets-button');
            if (facetsEl) facetsEl.classList.remove('ais-facets__shown');
            if (facetsEl) facetsEl.classList.remove('ais-sort__shown');

            if (facetsBtn) facetsBtn.innerHTML = '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_53_35764)"><path d="M13.4922 13.0075C13.9631 13.0075 14.415 13.1951 14.748 13.528C14.96 13.74 15.1121 14.0005 15.1953 14.2829H16.5195C16.7954 14.2831 17.0194 14.507 17.0195 14.7829C17.0195 15.0589 16.7955 15.2827 16.5195 15.2829H15.1953C15.1122 15.5658 14.9602 15.8266 14.748 16.0388C14.415 16.3717 13.9631 16.5583 13.4922 16.5583C13.0215 16.5582 12.5702 16.3715 12.2373 16.0388C12.0251 15.8266 11.8732 15.5658 11.79 15.2829H4.5625C4.28636 15.2829 4.0625 15.059 4.0625 14.7829C4.0627 14.5069 4.28648 14.2829 4.5625 14.2829H11.79C11.8733 14.0005 12.0253 13.74 12.2373 13.528C12.5702 13.1952 13.0214 13.0076 13.4922 13.0075ZM13.4922 14.0075C13.2866 14.0076 13.0897 14.0898 12.9443 14.235C12.799 14.3804 12.7169 14.5774 12.7168 14.7829C12.7168 14.9885 12.7989 15.1863 12.9443 15.3317C13.0897 15.4769 13.2867 15.5582 13.4922 15.5583C13.6979 15.5583 13.8956 15.4771 14.041 15.3317C14.1864 15.1863 14.2686 14.9885 14.2686 14.7829C14.2684 14.5775 14.1863 14.3804 14.041 14.235C13.8956 14.0897 13.6979 14.0075 13.4922 14.0075ZM8.22656 8.2243C8.69745 8.2243 9.14941 8.4119 9.48242 8.74481C9.69442 8.95684 9.84646 9.21721 9.92969 9.49969H16.5195L16.6211 9.50946C16.8487 9.55622 17.0195 9.75825 17.0195 9.99969C17.0195 10.2412 16.8487 10.4432 16.6211 10.4899L16.5195 10.4997H9.92969C9.84651 10.7826 9.69459 11.0434 9.48242 11.2556C9.14942 11.5884 8.69739 11.7751 8.22656 11.7751C7.75595 11.7749 7.30455 11.5882 6.97168 11.2556C6.75953 11.0434 6.60757 10.7826 6.52441 10.4997H4.5625C4.28636 10.4997 4.0625 10.2758 4.0625 9.99969C4.06256 9.7236 4.28639 9.49969 4.5625 9.49969H6.52441C6.6076 9.21721 6.75965 8.95687 6.97168 8.74481C7.30457 8.41196 7.75582 8.22444 8.22656 8.2243ZM8.22656 9.2243C8.021 9.22444 7.82406 9.30652 7.67871 9.45184C7.53818 9.5924 7.45745 9.78109 7.45215 9.97919C7.45243 9.98601 7.4541 9.9928 7.4541 9.99969C7.4541 10.0062 7.4524 10.0128 7.45215 10.0192C7.45717 10.2178 7.53791 10.4077 7.67871 10.5485C7.82403 10.6936 8.02115 10.7749 8.22656 10.7751C8.43219 10.7751 8.62994 10.6938 8.77539 10.5485C8.92086 10.4031 9.00293 10.2054 9.00293 9.99969C9.00289 9.79416 8.92073 9.59724 8.77539 9.45184C8.62993 9.30645 8.43228 9.2243 8.22656 9.2243ZM11.5762 3.4411C12.0471 3.4411 12.499 3.62864 12.832 3.96161C13.044 4.17365 13.1961 4.43399 13.2793 4.71649H16.5225L16.623 4.72626C16.8511 4.77272 17.0225 4.97472 17.0225 5.21649C17.0225 5.45826 16.8511 5.66026 16.623 5.70673L16.5225 5.71649H13.2793C13.1961 5.99938 13.0442 6.26019 12.832 6.47235C12.499 6.80525 12.047 6.99188 11.5762 6.99188C11.1055 6.99179 10.6542 6.80507 10.3213 6.47235C10.1091 6.26019 9.95719 5.99938 9.87402 5.71649H4.5625C4.28636 5.71649 4.0625 5.49263 4.0625 5.21649C4.06256 4.9404 4.28639 4.71649 4.5625 4.71649H9.87402C9.95723 4.43398 10.1092 4.17367 10.3213 3.96161C10.6542 3.62872 11.1054 3.44119 11.5762 3.4411ZM11.5762 4.4411C11.3705 4.44119 11.1737 4.52327 11.0283 4.66864C10.8877 4.80921 10.8071 4.99784 10.8018 5.19598C10.802 5.20281 10.8037 5.2096 10.8037 5.21649C10.8037 5.22302 10.802 5.22956 10.8018 5.23602C10.8068 5.43463 10.8875 5.62448 11.0283 5.76532C11.1737 5.91049 11.3707 5.99179 11.5762 5.99188C11.7818 5.99188 11.9795 5.91066 12.125 5.76532C12.2705 5.61987 12.3525 5.42216 12.3525 5.21649C12.3525 5.01095 12.2703 4.81404 12.125 4.66864C11.9795 4.52319 11.7819 4.4411 11.5762 4.4411Z" fill="#1B1B1B"/></g><defs><clipPath id="clip0_53_35764"><rect width="20" height="20" fill="white" transform="translate(0.5)"/></clipPath></defs></svg><span>Filter</span>';
        }


        // Radio button clicks
        if (e.target.matches("input[name='custom_sort_radio']")) {
            console.log('Radio clicked:', e.target.value);
            const sortBySelect = document.querySelector(".ais-SortBy-select");
            if (sortBySelect) {
                sortBySelect.value = e.target.value;
                sortBySelect.dispatchEvent(new Event("change"));
            }
        }

        // Radio button clicks
        if (e.target.closest(".ais-sort-button")) {
            console.log('Sort clicked:', e.target);
            const facetsEl2 = document.querySelector('.ais-facets');
            if (facetsEl2) facetsEl2.classList.add('ais-sort__shown');
        }

        // Outside click to close facets
        const facetsEl = document.querySelector('.ais-facets');
        const facetsBtn = document.querySelector('.ais-facets-button');
        const sortBtn = document.querySelector('.ais-sort-button');
        
        if (!facetsEl && 
            (facetsEl.classList.contains('ais-facets__shown') || facetsEl.classList.contains('ais-sort__shown')) &&
            !facetsEl.contains(e.target) && 
            (!facetsBtn || !facetsBtn.contains(e.target)) &&
            (!sortBtn || !sortBtn.contains(e.target))) {
            console.log('Outside click - closing facets');
            facetsEl.classList.remove('ais-facets__shown');
            facetsEl.classList.remove('ais-sort__shown');
            if (facetsBtn) facetsBtn.textContent = 'Filter';
        }
    });

    // Close on resize to desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth > 749) {
        const facetsEl = document.querySelector('.ais-facets');
        const facetsBtn = document.querySelector('.ais-facets-button');
        if (facetsEl) facetsEl.classList.remove('ais-facets__shown');
        if (facetsBtn) facetsBtn.textContent = 'Filter';
        }
    });
    
    console.log('Event listeners added');
    }

    console.log('Search interface initialization complete');
    
} catch (error) {
    console.error('Error initializing search interface:', error);
}
})();
  
  // Also run on DOM ready as fallback
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        if (!window.searchInterfaceInitialized) {
        console.log('Running via DOMContentLoaded');
        // Re-run the initialization
        window.searchInterfaceInitialized = false;
        initSearchInterface();
        }
    });
}
// Update filter count in data attribute
function updateFilterCount() {
    const refinedItems = document.querySelectorAll('.ais-current-refined-values--item');
    const facetsButton = document.querySelector('.ais-facets-button');
    
    if (facetsButton) {
      const count = refinedItems.length;
      facetsButton.setAttribute('data-filter-count', count);
      
      // Set CSS custom property for child access
      facetsButton.style.setProperty('--filter-count', `"${count}"`);
      
    }
  }
  
  // Update immediately
  updateFilterCount();
  
  // Update periodically to catch dynamic changes
  setInterval(updateFilterCount, 500);
  
  // Also update on any click/change events that might affect filters
  document.addEventListener('click', () => {
    setTimeout(updateFilterCount, 100);
  });

  // Update result count in collection hero
function updateResultCount() {
    const nbResultsSpan = document.querySelector('.ais-stats--nb-results');
    const collectionCountSpan = document.querySelector('.collection-count');
    
    if (nbResultsSpan && collectionCountSpan) {
        const resultCount = nbResultsSpan.textContent.trim();
        collectionCountSpan.textContent = resultCount;
    }
}

// Update immediately
updateResultCount();

// Update periodically to catch dynamic changes
setInterval(updateResultCount, 500);

// Also update on any click/change events that might affect results
document.addEventListener('click', () => {
    setTimeout(updateResultCount, 100);
});

// Watch for changes in the stats container specifically
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('ais-stats--nb-results') || 
            mutation.target.closest('.ais-stats-container')) {
            updateResultCount();
        }
    });
});

// Start observing when stats container is available
setTimeout(function() {
    const statsContainer = document.querySelector('.ais-stats-container');
    if (statsContainer) {
        observer.observe(statsContainer, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }
}, 1000);


// Update result count in collection hero (number only)
function updateResultCount() {
    const nbResultsSpan = document.querySelector('.ais-stats--nb-results');
    const collectionCountSpans = document.querySelectorAll('.collection-count');
    
    if (nbResultsSpan && collectionCountSpans.length > 0) {
        let resultCount = nbResultsSpan.textContent.trim();
        // Remove "found" if it exists
        resultCount = resultCount.replace(/\s*results found\s*/i, ' products');
        
        // Update all collection-count elements
        collectionCountSpans.forEach(span => {
            span.textContent = resultCount;
        });
        
    }
}

// Update immediately
updateResultCount();

// Update periodically to catch dynamic changes
setInterval(updateResultCount, 500);

// Also update on any click/change events that might affect results
document.addEventListener('click', () => {
    setTimeout(updateResultCount, 100);
});

// Watch for changes in the specific span
const observerResult = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('ais-stats--nb-results')) {
            updateResultCount();
        }
    });
});

setTimeout(function() {
    const nbResultsSpan = document.querySelector('.ais-stats--nb-results');
    if (nbResultsSpan) {
        observerResult.observe(nbResultsSpan, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
}, 1000);


function getParamFromURL(url, param) {
    let urlObj = new URL(url);
    let params = new URLSearchParams(urlObj.search);
    return params.get(param);
  }
  
  async function paginationInit() {
    const urlParams2 = new URLSearchParams(window.location.search);
    let pageNo = urlParams2.get('page');
    
    // await waitForElm('.ais-Pagination-item--page');
    
    const lastPageLink = document.querySelector('.ais-Pagination-item--lastPage .ais-Pagination-link');
    let lastPageHref = lastPageLink ? lastPageLink.getAttribute('href') : null;
    let last_page_number = lastPageHref ? getParamFromURL(lastPageHref, 'page') : pageNo;
    last_page_number = parseInt(last_page_number);
    // Remove dots_pagination class from all page items
    const pageItems = document.querySelectorAll('.ais-Pagination-item--page');
    pageItems.forEach(item => item.classList.remove('dots_pagination'));
  
    
    const pageItemsAll = document.querySelectorAll('.ais-Pagination-item--page');
    const lastPageItem = pageItemsAll[pageItemsAll.length - 1];
    
    if (lastPageItem) {
      const lastPageLink = lastPageItem.querySelector('a');
      let second_last = lastPageLink ? lastPageLink.getAttribute('aria-label').replace('Page ', '') : null;
      second_last = parseInt(second_last);
      if (last_page_number !== second_last && last_page_number !== second_last - 1) {
        lastPageItem.classList.add('dots_pagination');
      } else {
        if (last_page_number === second_last) {
          lastPageItem.classList.add('same_page_hide');
        } else {
          lastPageItem.classList.remove('dots_pagination');
        }
      }
      
      // Update last page link text
      if (document.querySelector('.ais-Pagination-item--lastPage a')) {
        document.querySelector('.ais-Pagination-item--lastPage a').textContent = last_page_number;
      }
      
      // Move next page after last page
      const nextPageItem = document.querySelector('.ais-Pagination-item--nextPage');
      const lastPageContainer = document.querySelector('.ais-Pagination-item--lastPage');
      if (nextPageItem && lastPageContainer) {
        lastPageContainer.insertAdjacentElement('afterend', nextPageItem);
      }
      
      // Update next/previous page text
      const nextPageLink = document.querySelector('.ais-Pagination-item--nextPage .ais-Pagination-link');
      const prevPageLink = document.querySelector('.ais-Pagination-item--previousPage .ais-Pagination-link');
      
      if (nextPageLink) {
        nextPageLink.innerHTML = 'Next <span class="mb-hide">Page</span>';
      }
      if (prevPageLink) {
        prevPageLink.innerHTML = 'Previous <span class="mb-hide">Page</span>';
      }
      
      setTimeout(() => {
        handlePaginationDisplay();
      }, 1500);
    } else {
      setTimeout(() => {
        handlePaginationDisplay();
      }, 1500);
    }
  }
  
  function handlePaginationDisplay() {
    const urlParams3 = new URLSearchParams(window.location.search);
    let pageNo2 = urlParams3.get('page');
    const paginationItems = document.querySelectorAll('.ais-Pagination-item');
    paginationItems.forEach(item => {
      if (item.classList.contains('same_page_hide')) {
        item.setAttribute("style", "display: none !important");
      } else {
        item.setAttribute("style", "display: block !important");
      }
    });
  
    // Handle selected page display
    const selectedItem = document.querySelector('.ais-Pagination-item--selected');
    const pageItemsCount = document.querySelectorAll('.ais-Pagination-item--page').length;
    
    if (selectedItem) {
      if (pageItemsCount === 1) {
        const pageItems = document.querySelectorAll('.ais-Pagination-item--page');
        pageItems.forEach(item => item.style.display = 'none');
      } else {
        const selectedLink = selectedItem.querySelector('a');
        if (selectedLink) {
          const selectedPageNum = parseInt(selectedLink.getAttribute('aria-label').replace('Page ', ''));
          if (selectedPageNum === parseInt(pageNo2)) {
            selectedItem.setAttribute("style", "display: block !important");
            selectedItem.classList.remove("dots_pagination");
          }
        }
      }
    }
  }
  

function detectShopifyPageType(url) {
  if (url.includes('/products/')) {
    return 'product';
  } else if (url.includes('/collections/')) {
    return 'collection';
  } else if (url.includes('/search?')) {
    return 'search';
  } else {
    return 'Unknown Page Type';
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let currentUrl = window.location.href;
  let pageType = detectShopifyPageType(currentUrl);

  if (pageType === "collection") {
    let breadcrumbBranch = document.querySelectorAll('#uncomplicated-breadcrumbs .breadcrumb__branch');
    if (breadcrumbBranch.length > 0) {
      let lastBreadcrumb = breadcrumbBranch[breadcrumbBranch.length - 1];
      lastBreadcrumb.style.textDecoration = "none";
      lastBreadcrumb.setAttribute("href", "javascript:;");
    }
  }
});